import { Directive } from '@angular/core';

/**
 * `[nbInput]` — applies the design-system text-control look to a native
 * `<input>`, `<textarea>` or `<select>` (Mockup `.input`). Keeps the native
 * element (and all its accessibility/validation) intact.
 *
 * @example <input nbInput type="email" placeholder="navn@epost.no" />
 */
@Directive({
  selector: 'input[nbInput], textarea[nbInput], select[nbInput]',
  host: { class: 'input' },
})
export class NbInput {}
